import { render } from "./ClubSummary.vue?vue&type=template&id=76fa7b85&scoped=true"
import script from "./ClubSummary.vue?vue&type=script&lang=js"
export * from "./ClubSummary.vue?vue&type=script&lang=js"

import "./ClubSummary.vue?vue&type=style&index=0&id=76fa7b85&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fa7b85"]])

export default __exports__